import { faCalendarCheck, faCheckCircle, faClockFour, faEnvelope, faLocationDot, faMailBulk, faMapPin, faMobileAlt, faNoteSticky, faPhone, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Avatar, Button, Card, CardContent, CardHeader, Chip, Divider, makeStyles, Typography } from '@material-ui/core';
import moment from "moment-timezone";
import { LocationConfirmDialog } from 'pages/CustomerBooking/LocationConfirmation/ConfirmDialog';
import { isLocationRequiredPopupState, locationRequiredState } from 'pages/CustomerBooking/RecoilState';
import React, { useEffect, useMemo } from 'react';
import ReactJson from 'react-json-view';
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { getMaxicareCardInfo } from 'services/client.service';
import { canReschedule, isCancelled } from 'util/bookingStates';
import { formatAddressObject, fuzzyDate, personNameFormal } from 'util/format';
import { useState } from 'util/stateref';



const useStyles = makeStyles((theme) => {
  return {
    statusChip: {
      marginLeft: theme.spacing(1)
    },
    cardHeaderAction: {
      margin: "auto"
    },
    maxicareId: {
      ...theme.typography.body2
    },
    extras: {
      display: 'flex',
      flexWrap: 'wrap',
      listStyle: 'none',
      padding: theme.spacing(0.5),
      margin: 0,
    },
    extrachip: {
      margin: theme.spacing(0.5),
    },
    datalist: {
      "&>*": {
        paddingBottom: theme.spacing(1)
      }
    }
  }
})
const Client = ({ userLocation, client, booking, onReschedule }) => {
  const classes = useStyles()

  const locationRequired = useRecoilValue(locationRequiredState)
  const locationRequiredStatePopup = useRecoilValue(isLocationRequiredPopupState)
  const setLocationRequiredStatePopup = useSetRecoilState(isLocationRequiredPopupState)

  const [open, setOpen] = useState(false);

  const address = useMemo(() => {
    return <>
      {formatAddressObject(userLocation)}
      {/* {(booking?.is_whitelabel && !isCancelled(booking)) && (
        <Button
          className={classes.statusChip}
          size="small"
          variant='contained'
          color='primary'
          onClick={() => {
            setLocationRequiredStatePopup(true)
          }}>
          {locationRequired ? 'Confirm Location' : 'Update Location'}
        </Button>
      )} */}
    </>

  }, [locationRequired, userLocation]);

  const [maxicareCardNumber, setMaxicareCardNumber] = useState('');

  useEffect(() => {
    const fetchMaxicareCardInfo = async () => {
      const mcard = booking?.white_label_customer?.card_number
      const formattedCard = mcard?.match(/.{1,4}/g)?.join('-')
      setMaxicareCardNumber(formattedCard)
    }
    fetchMaxicareCardInfo()
  }, [booking?.white_label_customer?.card_number])

  const renderIdentifier = useMemo(() => {
    const customerIdentifier = booking?.white_label_partner?.settings?.customer_identifier

    if (!customerIdentifier) return ''
    const clutchInfo = booking?.white_label_customer || booking?.client
    const identifierValue = clutchInfo?.[customerIdentifier?.value]
    const formattedIdentifier = identifierValue ? identifierValue?.match(/.{1,4}/g)?.join('-') : '-'
    return (
      <>
        <strong>{customerIdentifier?.label}</strong>{": "}
        {formattedIdentifier}
      </>
    )

  }, [booking?.white_label_customer, booking?.white_label_partner])


  return (
    <>
      <Card color='primary'>
        <CardHeader
          title={personNameFormal(booking?.white_label_customer || booking?.client)}
          subheader={renderIdentifier}
          action={(canReschedule(booking) && onReschedule) ? <Button size="small" variant='outlined' color='secondary' onClick={() => {
            onReschedule()
          }}>Reschedule</Button> : <></>}
          classes={{
            action: classes.cardHeaderAction,
            subheader: classes.maxicareId
          }}
        />
        <CardContent className={classes.datalist}>
          <Typography variant="body1" color="textSecondary" component="p"><FontAwesomeIcon fixedWidth icon={faCalendarCheck} /> {moment(booking?.date_scheduled).format('dddd LL')}</Typography>
          <Typography variant="body1" color="textSecondary" component="p"><FontAwesomeIcon fixedWidth icon={faClockFour} /> {moment(booking?.date_scheduled).format('LT')} - {moment(booking?.date_scheduled_end).format('LT')}</Typography>
          <Typography variant="body1" color="textSecondary" component="p"><FontAwesomeIcon fixedWidth icon={faLocationDot} /> {address}</Typography>
          <Typography variant="body1" color="textSecondary" component="p"><FontAwesomeIcon fixedWidth icon={faPhone} /> {booking?.white_label_customer?.mobile_number || booking?.client?.mobile_number}</Typography>
          <Typography variant="body1" color="textSecondary" component="p"><FontAwesomeIcon fixedWidth icon={faEnvelope} /> {booking?.white_label_customer?.email || booking?.client?.email}</Typography>

        </CardContent>
        {booking?.booking_notes &&
          <CardContent>
            <Divider />
            <Typography variant="caption" color="textSecondary" component="p">Special Instructions:</Typography>
            <Typography variant="body2" color="textSecondary" component="p">{booking?.booking_notes}</Typography>
          </CardContent>
        }
        <Divider />
        {
          <CardContent
            style={{
              fontStyle: "italic",
              textAlign: "center"
            }}>
            <Typography
              variant="caption"
              
            >
              Your result will be sent privately to your email address.
            </Typography>
          </CardContent>
        }
      </Card>
    </>
  )
}

export { Client };
